module.exports = __webpack_public_path__ + "static/media/iot2.249a1ca8.png";